export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1676743603171-46338ba7cafc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  engineSteel: "/photos/service-preparation.jpg",
  engineRed: "/photos/hp-8135.webp",
  darkCar: "/photos/hp-5437.webp",
  sportsDark: "/photos/hp-9074.webp",
  bmw: "/photos/hp-9165.webp",
  taillights: "/photos/service-e85.jpg",
  ecuLaptop: "/photos/hp-8397.webp",
  ecuMitsu: "/photos/service-diagnostic.jpg",
  gearbox: "/photos/service-boite-auto.jpg",
  garage1: "/photos/hp-8467.webp",
  gallery: ["/photos/hp-8467-sm.webp", "/photos/hp-9605-sm.webp", "/photos/hp-8397-sm.webp", "/photos/hp-5002-sm.webp", "/photos/hp-2193-sm.webp", "/photos/hp-6282-sm.webp"],
};

export const STAGES = {
  "stage-1": {
    name: "Stage 1", short: "Optimisation moteur d'origine",
    hero: "/photos/hp-2193.webp",
    intro: "La reprogrammation Stage 1 exploite le potentiel de votre moteur sans modification mécanique. Nous développons une cartographie moteur sur mesure pour gagner en puissance, en couple et en agrément, tout en préservant la fiabilité.",
    points: [
      "Gain de puissance et de couple sur toute la plage de régime",
      "Meilleure réactivité et souplesse à bas régime",
      "Aucune modification mécanique nécessaire",
      "Cartographie sur mesure, jamais un fichier générique",
      "Validation et contrôle au banc de puissance",
    ],
    gains: "Généralement +20 à +30% de puissance selon la motorisation.",
  },
  "stage-2": {
    name: "Stage 2", short: "Reprogrammation + modifications matérielles",
    hero: "/photos/hp-5002.webp",
    intro: "Le Stage 2 associe la reprogrammation à des modifications matérielles (ligne d'échappement, admission, intercooler, downpipe…). La cartographie est développée en fonction de vos évolutions pour un gain supérieur et maîtrisé.",
    points: [
      "Cartographie adaptée aux modifications matérielles installées",
      "Gain de puissance supérieur au Stage 1",
      "Optimisation de la gestion moteur (suralimentation, injection)",
      "Accompagnement sur le choix des pièces",
      "Développement et validation au banc de puissance",
    ],
    gains: "Gains supérieurs au Stage 1, dépendant des modifications réalisées.",
  },
  "stage-3": {
    name: "Stage 3", short: "Préparation moteur poussée",
    hero: "/photos/hp-8135.webp",
    intro: "Le Stage 3 s'adresse aux préparations poussées : évolutions turbo, moteur, injection. Il nécessite une étude spécifique, un développement sur mesure et de nombreuses sessions au banc de puissance.",
    points: [
      "Préparation moteur et suralimentation avancée",
      "Étude technique et développement dédié",
      "Cartographie 100% sur mesure, logs et mise au point",
      "Nombreux passages au banc de puissance",
      "Suivi et validation par nos ingénieurs moteur",
    ],
    gains: "Sur devis, selon le projet et les composants.",
  },
};

export const SERVICES = [
  { slug: "e85", name: "Conversion E85 / FlexFuel", desc: "Roulez à l'éthanol E85 et réduisez votre budget carburant, tout en préservant les performances.", image: IMAGES.taillights, path: "/services/e85" },
  { slug: "banc-de-puissance", name: "Banc de puissance", desc: "Mesure de puissance et de couple, contrôle avant/après et validation de chaque cartographie.", image: IMAGES.sportsDark, path: "/services/banc-de-puissance" },
  { slug: "diagnostic", name: "Diagnostic", desc: "Analyse électronique complète du véhicule avec équipements professionnels.", image: IMAGES.ecuMitsu, fit: "cover", path: "/services/diagnostic" },
  { slug: "preparation", name: "Préparation automobile", desc: "Accompagnement sur mesure pour votre projet de préparation moteur et performance.", image: IMAGES.engineSteel, fit: "cover", path: "/services/preparation" },
  { slug: "revision-boite-auto", name: "Révision boîte automatique", desc: "Vidange dynamique à la machine avec additif de rinçage et additif de protection : votre boîte retrouve douceur et fiabilité.", image: "/photos/service-boite-auto-card.jpg", path: "/services/revision-boite-auto" },
];

export const SERVICE_DETAIL = {
  diagnostic: {
    name: "Diagnostic", eyebrow: "Service", image: IMAGES.ecuMitsu,
    intro: "Un diagnostic électronique complet pour identifier précisément l'état et les défauts de votre véhicule avant toute intervention.",
    points: ["Lecture et analyse des codes défauts", "Contrôle moteur et systèmes électroniques", "Vérification des paramètres en temps réel", "Rapport clair et recommandations"],
  },
  preparation: {
    name: "Préparation automobile", eyebrow: "Service", image: IMAGES.engineSteel,
    intro: "De l'optimisation moteur à la préparation performance, nos ingénieurs vous accompagnent sur l'ensemble de votre projet automobile.",
    points: ["Étude et conseil sur votre projet", "Choix des composants et évolutions", "Reprogrammation adaptée aux modifications", "Mise au point et validation au banc"],
  },
  "revision-boite-auto": {
    name: "Révision boîte automatique", eyebrow: "Service entretien", image: "/photos/boite-auto-1.jpg",
    intro: "Une vidange classique ne remplace que 40 à 60 % de l'huile de votre boîte automatique. Avec notre machine de vidange dynamique, nous renouvelons jusqu'à 100 % du fluide, après un rinçage complet du circuit et avec un additif de protection longue durée.",
    points: [
      "Vidange dynamique à la machine : jusqu'à 100 % de l'huile remplacée (convertisseur et radiateur inclus)",
      "Additif de rinçage : dissout les dépôts, vernis et résidus d'usure dans tout le circuit hydraulique",
      "Additif de protection : réduit les frottements, protège les joints et stabilise la température",
      "Huile ATF homologuée constructeur, au litre près selon les préconisations",
      "Remplacement du filtre et du joint de carter si nécessaire",
      "Contrôle du niveau à température, essai routier et remise à zéro des adaptatifs",
    ],
    steps: [
      { n: "01", t: "Diagnostic", d: "Lecture des défauts boîte, contrôle de l'état et de la couleur de l'huile, essai routier." },
      { n: "02", t: "Rinçage", d: "Injection de l'additif de rinçage puis cycle de nettoyage moteur tournant pour décoller les dépôts." },
      { n: "03", t: "Vidange dynamique", d: "La machine remplace l'huile usagée par de l'huile neuve, en circuit, jusqu'à ce que le fluide ressorte propre." },
      { n: "04", t: "Protection", d: "Ajout de l'additif de protection, filtre neuf, mise à niveau à température et essai final." },
    ],
    why: [
      { t: "Passages plus doux", d: "Disparition des à-coups, hésitations et patinages liés à une huile dégradée." },
      { t: "Fiabilité préservée", d: "Un fluide propre protège le convertisseur, les embrayages et le bloc hydraulique." },
      { t: "Économies", d: "Évite des réparations de boîte très coûteuses et maintient la valeur du véhicule." },
      { t: "Toutes boîtes", d: "Automatiques classiques, double embrayage (DSG, PDK, DCT), CVT et robotisées." },
    ],
    note: "Préconisé tous les 60 000 km ou 4 ans, et avant toute reprogrammation moteur Stage 2/3 pour accompagner la hausse de couple.",
    gallery: ["/photos/boite-auto-3.jpg", "/photos/boite-auto-2.jpg", "/photos/boite-auto-4.jpg", "/photos/boite-auto-1.jpg"],
  },
};

export const E85_FAQ = [
  { q: "Qu'est-ce que l'E85 ?", a: "Le Superéthanol-E85 est un carburant composé d'éthanol (issu de matières végétales) et d'essence. C'est un biocarburant renouvelable, généralement bien moins cher que le SP95/SP98 à la pompe." },
  { q: "Comment fonctionne une reprogrammation FlexFuel ?", a: "Nous intervenons sur le calculateur moteur (ECU) pour adapter la gestion de l'injection et de l'allumage à l'éthanol. La cartographie détecte et s'adapte au carburant présent dans le réservoir." },
  { q: "Le véhicule peut-il encore rouler au SP98 ?", a: "Oui. Lorsque la configuration du véhicule le permet, le fonctionnement FlexFuel autorise l'utilisation d'essence, d'E85 ou d'un mélange des deux, sans intervention supplémentaire." },
  { q: "Est-ce sans risque pour le moteur ?", a: "La conversion est réalisée après contrôle du véhicule et de sa compatibilité. La cartographie est développée pour préserver la fiabilité du moteur." },
  { q: "Combien de temps dure l'intervention ?", a: "L'intervention est généralement réalisée dans la journée, après contrôle du véhicule. La durée exacte dépend du modèle." },
  { q: "Comment vérifier la compatibilité de mon véhicule ?", a: "Indiquez-nous votre véhicule via le configurateur ou le formulaire : nous vérifions la compatibilité et vous conseillons." },
];
